// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-templates----page-disclaimer-module---wrapper---3DaqP","content":"src-templates----page-disclaimer-module---content---2bFAH"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/page.disclaimer.module.css
// module id = 730
// module chunks = 89101337168390